export function removeUser () {
  localStorage.removeItem('user')
}
